import React, { ReactElement, useEffect, useState } from 'react';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import { useLocation, useParams } from 'react-router';
import routes from '../../../../routing/routes';
import GlobalErrors from '../../../../module/GlobalErrors';
import PageHeadingWithBackButton from '../../../../module/PageHeadingWithBackButton';
import Layout from '../../../Layout';
import { UlohyOrganizacieDetail } from '../../../../module/LegislativnyMaterial/Ulohy';
import { UserRoleEnum } from '../../../../model/currentuser/UserRole';
import { pouzivalHasLegOrg } from '../../../../function/permissions';
import SecuredPage from '../../../../module/SecuredPage';
import { useUserContext } from '../../../../context/UserContext';
import SuccessMessages from '../../../../module/SuccessMessages';
import useHistoryPageContext
  from '../../../../context/BreadcrumbContext/hook/useHistoryPageContext';
import { useClientFetch } from '../../../../context/ClientStatusContext';
import { fetchPouzivatel } from '../../../../client/external/iam/pouzivatelClient';

const UlohyOrganizacieListPage = (): ReactElement => {
  const { pathname } = useLocation();
  const { pouzivatel: pouzivatelActual } = useUserContext();
  const [pageStatus, setPageStatus] = useState<number>(null);
  const {
    uuid,
  } = useParams<{ uuid: string }>();

  const {
    data: pouzivatel,
  } = useClientFetch(fetchPouzivatel, [null, uuid, true], [uuid]);

  useEffect(() => {
    if (pouzivatel) {
      setTitle(getTitle());
    }
  }, [pouzivatel]);

  const { setHistoryPages } = useHistoryPageContext();
  useEffect(() => {
    setHistoryPages([
      { heading: 'Úlohy organizácie', to: routes.ulohyOrganizacie.list },
      {
        heading: routes.ulohyOrganizacie.detail.name(pouzivatel ? pouzivatel.nazov : ''),
        to: pathname,
      }]);
  }, [pathname, pouzivatel, setHistoryPages]);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: 'Úlohy organizácie',
          to: routes.ulohyOrganizacie.list,
        },
        {
          heading: routes.ulohyOrganizacie.detail
            .name(pouzivatel ? pouzivatel.nazov : ''),
          to: pathname,
        },
      ]}
      />
      <GlobalErrors />
      {pouzivatel && (
      <SecuredPage
        allowForRoles={[UserRoleEnum.VEDUCI_ORGANIZACIE]}
        additionalCheck={pouzivalHasLegOrg(pouzivatelActual)}
        requestStatus={pageStatus}
      >
        <>
          <SuccessMessages />
          <PageHeadingWithBackButton
            heading={pouzivatel ? pouzivatel.nazov : ''}
            headingCaption="Úlohy organizácie"
            withBackLink
          />
          <UlohyOrganizacieDetail setPageStatus={setPageStatus} />
        </>
      </SecuredPage>
      )}
    </Layout>
  );
};

export default UlohyOrganizacieListPage;
